// skipcq: JS-W1028
import React, { useCallback } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { useTheme } from '@mui/material/styles';

import { UserContext } from '../../context/UserContext';
import {
  readBreweryIdQueryParam,
  storeClaimBreweryHandoff,
} from '../../utils/claimBreweryHandoff';
import { getVerifiedUserDestination } from '../../utils/verifiedUserDestination';
import { parchmentStack } from '../../utils/vintageSurfaces';
import LoginHeader from './LoginHeader';
import LoginColumns from './LoginColumns';


function Login() {
  const theme = useTheme();
  const user = React.useContext(UserContext);
  const location = useLocation();
  const navigate = useNavigate();
  const queryBreweryId = readBreweryIdQueryParam(location.search);
  if (queryBreweryId) {
    storeClaimBreweryHandoff(queryBreweryId);
  }

  const handleSignupSuccess = useCallback((signupResult = {}) => {
    const verificationEmailError = signupResult?.verificationEmailError;
    navigate('/verify-email', {
      replace: true,
      state:
        typeof verificationEmailError === 'string' && verificationEmailError.length > 0
          ? { verificationEmailError }
          : {},
    });
  }, [navigate]);

  if (user.isLoading) {
    return (
      <Box
        sx={{
          ...parchmentStack(theme.palette.background.default),
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <CircularProgress color="primary" />
      </Box>
    );
  }

  if (user.isLoggedIn && user.emailVerified === false) {
    return <Navigate to="/verify-email" replace />;
  }

  if (user.isLoggedIn && user.emailVerified === true) {
    return <Navigate to={getVerifiedUserDestination(user)} replace />;
  }

  return (
    <Box
      sx={{
        ...parchmentStack(theme.palette.background.default),
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <LoginHeader />
      <LoginColumns onSignupSuccessNavigate={handleSignupSuccess} />
    </Box>
  );
}

export default Login;
